import isEmpty from 'lodash/isEmpty'
import { format, parseISO } from 'date-fns'
import $api from '@/plugins/axiosInstance.js'
import CONST from '@/const.js'

const GET_ARTIST_TYPE_NAME_BY_CODE = (typeCode) => {
  let name = ''
  CONST.ARTIST_TYPE.some((type) => {
    if (type.code === typeCode) {
      name = type.name
      return true
    }
    return false
  })
  return name
}

const GET_SNS_TYPE_NAME_BY_CODE = (snsCode) => {
  let name = ''
  CONST.SNS_TYPE.some((type) => {
    if (type.code === snsCode) {
      name = type.name
      return true
    }
    return false
  })
  return name
}

const GET_LANGUAGE_NAME_BY_CODE = (langCode) => {
  let name = ''
  CONST.LANGUAGE.some((lang) => {
    if (lang.code === langCode) {
      name = lang.name
      return true
    }
    return false
  })
  return name
}

const GET_NATIONALITY_NAME_BY_CODE = (nationCode) => {
  let name = ''
  const compCode = nationCode ? nationCode.toUpperCase() : ''
  CONST.COUNTRY.some((c) => {
    if (c.code === compCode) {
      name = c.name
      return true
    }
    return false
  })
  return name
}

const state = {
  artistListObject: {},
  selectArtistInfo: {},
}

const getters = {
 
}

const mutations = {
  SET_QUERY_ARTIST_DATA (state, payload) {
    state.artistListObject = payload
  },
  SET_SELECTED_ARTIST_INFO (state, payload) {
    state.selectArtistInfo = payload
  },
}

const actions = {
 
  LIST_ARTIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/artist', params: payload}).then((result) => {
        return result.data
      })
    }
  },
 
  POST_ARTIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'post', url: '/artist', data: payload})
        .then(result =>{
          return result
        })
    }
  },
  PUT_ARTIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({method: 'put', url: '/artist/'+payload.id, data: payload})
        .then(result =>{
          return result
        })
    }
  },
  GET_ARTIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'get', url: '/artist/'+payload.id,}).then((result) => {
        return result
      })
    }
  },
  DELETE_ARTIST: {
    root: true,
    handler(namespacedContext, payload) {
      return $api({ method: 'delete', url: '/artist/'+payload.id,}).then((result) => {
        return result
      })
    }
  },
  GET_ARTIST_ALBUM: {
    root: true,
    handler(namespacedContext, payload) {
    return $api({ method: 'get', url: '/artist/'+payload.id+'/albums',params: payload.params}).then((result) => {
        return result.data
      })
    }
  },
  
}

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
}
